export const capitalize = string => {
  if (!string) return '';
  return string
    .trim()
    .split(' ')
    .map(s => (s ? s[0].toUpperCase() + s.slice(1).toLowerCase() : null))
    .filter(s => s)
    .join(' ');
};
